// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.wrapLogin {
  font-family: "Montserrat", sans-serif;
  position: absolute;
  width: 364px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.wrapLogin #logo {
  width: 100%;
  text-align: center;
  position: absolute;
  top: -45px;
}
.wrapLogin #logo .logo-name {
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 27px;
  text-transform: uppercase;
  color: #121b2b;
}
.wrapLogin #logo .logo-name .pool-color {
  color: #1ba192;
}
.wrapLogin #loginForm {
  width: 364px;
  left: 778px;
  top: 347px;
  background: #ffffff;
  box-shadow: 0px -1px 10px rgba(170, 170, 170, 0.15), 0px 8px 15px rgba(224, 224, 224, 0.35);
  border-radius: 15px;
}
.wrapLogin #loginForm .form-size {
  width: 100%;
  height: 100%;
}
.wrapLogin #loginForm .form-size .email-title {
  padding-left: 12px;
  margin-bottom: 10px;
}
.wrapLogin #loginForm .form-size .email-title .control-label {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  display: inline-block;
  padding-top: 27px;
}
.wrapLogin #loginForm .form-size .email-title .form-control {
  background: #ffffff;
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
  border-radius: 5px;
  height: 50px;
  padding: 0 18px;
  width: 305px;
}
.wrapLogin #loginForm .form-size .size-col {
  padding-left: 12px;
}
.wrapLogin #loginForm .form-size .size-col .password-title {
  width: 57px;
  height: 15px;
  margin-bottom: 9px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
}
.wrapLogin #loginForm .form-size .size-col .form-control {
  background: #ffffff;
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
  border-radius: 5px;
  height: 50px;
  padding: 0 18px;
  width: 305px;
}
.wrapLogin #loginForm .form-size .size-col .button-change {
  width: 305px;
  height: 49px;
  background: #66b6ab;
  border-radius: 5px;
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  color: #ffffff;
}
.wrapLogin #loginForm .form-size .size-col .alert-error-login {
  bottom: -5px;
  padding-top: 8px;
  width: 305px;
}
.wrapLogin #loginForm .form-size .forgot-pass {
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapLogin #loginForm .form-size .forgot-pass .forgot-title {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #666666;
}
.wrapLogin #loginForm .form-size .forgot-pass .forgot-title:hover {
  text-decoration: none;
}

@media all and (max-width: 480px) {
  .wrapLogin {
    width: 100% !important;
    top: 420px !important;
    display: flex;
    align-items: center;
  }
  .wrapLogin #loginForm {
    margin-left: 30px;
    width: 320px !important;
    height: 328px !important;
  }
  .wrapLogin #loginForm .form-size .email-title .form-control {
    height: 44px !important;
    width: 266px !important;
  }
  .wrapLogin #loginForm .form-size .size-col .form-control {
    height: 44px !important;
    width: 266px !important;
  }
  .wrapLogin #loginForm .form-size .size-col .button-change {
    width: 266px !important;
    height: 46px !important;
  }
  .wrapLogin #loginForm .form-size .size-col .alert-error-login {
    left: 8px !important;
    bottom: 8px !important;
    height: 36px !important;
    padding-top: 7px !important;
    width: 247px !important;
  }
  .wrapLogin #loginForm .form-size .forgot-pass {
    margin-left: 0 !important;
    bottom: 0px !important;
    text-align: center !important;
  }
  .wrapLogin #loginForm .form-size .forgot-pass .forgot-title span {
    padding-left: 0 !important;
  }
}
@media all and (min-width: 414px) and (max-width: 414px) {
  #loginForm {
    margin-left: 50px !important;
  }
}
.password-toggle-icon {
  position: absolute;
  top: 13px;
  right: 23px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
}`, "",{"version":3,"sources":["webpack://./src/app/main/login/login.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EAEA,gCAAA;AACF;AAAE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAEJ;AAAI;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AAEN;AADM;EACE,cAAA;AAGR;AACE;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,2FAAA;EAEA,mBAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AAAM;EACE,kBAAA;EACA,mBAAA;AAER;AADQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AAGV;AADQ;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAGV;AAAM;EACE,kBAAA;AAER;AADQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGV;AADQ;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAGV;AADQ;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAGV;AADQ;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AAGV;AAAM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAER;AADQ;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAGV;AAFU;EACE,qBAAA;AAIZ;;AAIA;EACE;IACE,sBAAA;IACA,qBAAA;IACA,aAAA;IACA,mBAAA;EADF;EAEE;IACE,iBAAA;IACA,uBAAA;IACA,wBAAA;EAAJ;EAGQ;IACE,uBAAA;IACA,uBAAA;EADV;EAKQ;IACE,uBAAA;IACA,uBAAA;EAHV;EAKQ;IACE,uBAAA;IACA,uBAAA;EAHV;EAKQ;IACE,oBAAA;IACA,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,uBAAA;EAHV;EAMM;IACE,yBAAA;IACA,sBAAA;IACA,6BAAA;EAJR;EAMU;IACE,0BAAA;EAJZ;AACF;AAYA;EACE;IACE,4BAAA;EAVF;AACF;AAaA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AAXF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.wrapLogin {\n  font-family: \"Montserrat\", sans-serif;\n  position: absolute;\n  width: 364px;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  #logo {\n    width: 100%;\n    text-align: center;\n    position: absolute;\n    top: -45px;\n\n    .logo-name {\n      font-style: normal;\n      font-weight: bold;\n      font-size: 25px;\n      line-height: 27px;\n      text-transform: uppercase;\n      color: #121b2b;\n      .pool-color {\n        color: #1ba192;\n      }\n    }\n  }\n  #loginForm {\n    width: 364px;\n    left: 778px;\n    top: 347px;\n    background: #ffffff;\n    box-shadow: 0px -1px 10px rgba(170, 170, 170, 0.15),\n      0px 8px 15px rgba(224, 224, 224, 0.35);\n    border-radius: 15px;\n    .form-size {\n      width: 100%;\n      height: 100%;\n      .email-title {\n        padding-left: 12px;\n        margin-bottom: 10px;\n        .control-label {\n          font-style: normal;\n          font-weight: 400;\n          font-size: 14px;\n          line-height: 15px;\n          color: #333333;\n          display: inline-block;\n          padding-top: 27px;\n        }\n        .form-control {\n          background: #ffffff;\n          border: 1px solid #d5d5d5;\n          box-sizing: border-box;\n          border-radius: 5px;\n          height: 50px;\n          padding: 0 18px;\n          width: 305px;\n        }\n      }\n      .size-col {\n        padding-left: 12px;\n        .password-title {\n          width: 57px;\n          height: 15px;\n          margin-bottom: 9px;\n          font-style: normal;\n          font-weight: 400;\n          font-size: 14px;\n          line-height: 15px;\n          color: #333333;\n        }\n        .form-control {\n          background: #ffffff;\n          border: 1px solid #d5d5d5;\n          box-sizing: border-box;\n          border-radius: 5px;\n          height: 50px;\n          padding: 0 18px;\n          width: 305px;\n        }\n        .button-change {\n          width: 305px;\n          height: 49px;\n          background: #66b6ab;\n          border-radius: 5px;\n          cursor: pointer;\n          font-style: normal;\n          font-weight: normal;\n          font-size: 16px;\n          line-height: 17px;\n          text-align: center;\n          color: #ffffff;\n        }\n        .alert-error-login {\n          bottom: -5px;\n          padding-top: 8px;\n          width: 305px;\n        }\n      }\n      .forgot-pass {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        .forgot-title {\n          font-style: normal;\n          font-weight: normal;\n          font-size: 16px;\n          line-height: 20px;\n          text-align: center;\n          color: #666666;\n          &:hover {\n            text-decoration: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media all and (max-width: 480px) {\n  .wrapLogin {\n    width: 100% !important;\n    top: 420px !important;\n    display: flex;\n    align-items: center;\n    #loginForm {\n      margin-left: 30px;\n      width: 320px !important;\n      height: 328px !important;\n      .form-size {\n        .email-title {\n          .form-control {\n            height: 44px !important;\n            width: 266px !important;\n          }\n        }\n        .size-col {\n          .form-control {\n            height: 44px !important;\n            width: 266px !important;\n          }\n          .button-change {\n            width: 266px !important;\n            height: 46px !important;\n          }\n          .alert-error-login {\n            left: 8px !important;\n            bottom: 8px !important;\n            height: 36px !important;\n            padding-top: 7px !important;\n            width: 247px !important;\n          }\n        }\n        .forgot-pass {\n          margin-left: 0 !important;\n          bottom: 0px !important;\n          text-align: center !important;\n          .forgot-title {\n            span {\n              padding-left: 0 !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media all and (min-width: 414px) and (max-width: 414px) {\n  #loginForm {\n    margin-left: 50px !important;\n  }\n}\n\n.password-toggle-icon {\n  position: absolute;\n  top: 13px;\n  right: 23px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.54);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
